<div class="u-cubeportfolio mb-5 mt-4">
  <!-- Content -->
  <div class="cbp" id="parkCubes"
       data-layout="grid"
       data-controls="#filterControls"
       data-animation="quicksand"
       data-x-gap="32"
       data-media-queries='[
        {"width": 1500, "cols": 3},
        {"width": 1100, "cols": 3},
        {"width": 800, "cols": 2},
        {"width": 480, "cols": 2},
        {"width": 300, "cols": 1}
      ]'>
    <!-- Item -->
    <div class="cbp-item rounded hotel" id="serengetiCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="480x480/serengeti-sunset.jpg"
               alt="Serengeti Vistas">
        </div>
        <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-pink' : 'bg-primary'"
             routerLink="/national-parks/serengeti">
          <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Serengeti National Park</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <!-- End Item -->

    <!-- Item -->
    <div class="cbp-item rounded hotel" id="ngorongoroCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="480x480/ngorongoro-thumb.jpg" alt="Ngorongoro Crater Rim looms over a vast population of animals beneath.">
        </div>
        <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-pink' : 'bg-primary'"
             routerLink="/national-parks/ngorongoro">
          <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Ngorongoro Crater Conservation Area</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <!-- End Item -->

    <!-- Item -->
    <div class="cbp-item rounded camp" id="iraqw-culture-centerCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="others/iraqw-woman-beading.jpg" alt="An Iraqw woman creates bead jewelry outside her home">
        </div>
        <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
             routerLink="/national-parks/iraqw-culture-center">
          <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Iraqw Culture Center</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <!-- End Item -->
    <!-- Item -->
    <div class="cbp-item rounded camp" id="lake-manyaraCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="480x480/manyara-giraffes.jpg" alt="View of Bedroom in Ngorongoro Wild Camp">
        </div>
        <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
             routerLink="/national-parks/lake-manyara">
          <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Lake Manyara National Park</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="cbp-item rounded lodge" id="olduvai-gorgeCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="1920x1080/olduvai-sediment-no-arrow.jpg"
               alt="Aerial view of Olduvai Gorge">
        </div>
        <div class="cbp-caption-activeWrap bg-primary" routerLink="/national-parks/olduvai-gorge">
        <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Olduvai Gorge</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <!-- End Item -->

    <!-- Item -->
    <div class="cbp-item rounded camp" id="tarangireCube">
      <a class="cbp-caption">
        <div class="cbp-caption-defaultWrap">
          <img width="320px" style="height:190px" appLazyload="others/tarangire-river.jpg" alt="Tarangire River with elephants">
        </div>
        <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
             routerLink="/national-parks/tarangire">
          <div class="cbp-l-caption-alignCenter">
            <div class="cbp-l-caption-body">
              <h4 class="h6 text-white mb-0">Tarangire National Park</h4>
              <p class="small text-white-70 mb-0">
                Click to learn more!
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
</div>
</div>
